// @todo: Migrate to 'Pill' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Pill} from '@wandb/weave/components/Tag';
import React, {FC} from 'react';

import {ServiceAccountAuthMethod} from '../../generated/graphql';

type ServiceAccountPillProps = {
  authMethod: ServiceAccountAuthMethod;
};

export const ServiceAccountAuthPill: FC<ServiceAccountPillProps> = ({
  authMethod,
}) => {
  return authMethod === ServiceAccountAuthMethod.ApiKey ? (
    <Pill className="ml-6" label="Built in" color="teal" />
  ) : (
    <Pill className="ml-6" label="External" color="sienna" />
  );
};
